import { Box, Card, Typography } from "@mui/material";
import React, { useRef } from "react";

const RPICard = ({ employeeData }) => {

    const projects = employeeData?.project_rpi_list || [];

    const scrollRef = useRef(null);
    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
        isDown = true;
        scrollRef.current.classList.add("active");
        startX = e.pageX - scrollRef.current.offsetLeft;
        scrollLeft = scrollRef.current.scrollLeft;
    };

    const handleMouseLeave = () => {
        isDown = false;
        scrollRef.current.classList.remove("active");
    };

    const handleMouseUp = () => {
        isDown = false;
        scrollRef.current.classList.remove("active");
    };

    const handleMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 2; // scroll speed
        scrollRef.current.scrollLeft = scrollLeft - walk;
    };

    return (
        <Card
            sx={{
                height: "165px",
                width: "100%",
                borderRadius: 3,
                overflow: "hidden",
                p: 1,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    alignItems: "center",
                    mb: 1,
                }}
            >
                <Typography variant="h5" fontWeight="bold">
                    Overall RPI :
                </Typography>
                <Typography variant="h5" fontWeight="bold">
                    {employeeData?.monthly_rpi || 0}
                </Typography>
            </Box>
            {projects.length === 0 ? (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                    }}
                >
                    <Typography variant="h6" color="text.secondary" fontFamily='sans-serif' fontWeight='bold' fontStyle='italic'>
                        No RPI Data Found
                    </Typography>
                </Box>
            ) : (
                <Box
                    ref={scrollRef}
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        overflowX: "auto",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                        p: 1,
                        cursor: "grab",
                    }}
                    className="scroll-box"
                    onMouseDown={handleMouseDown}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                >
                    {projects.map((project, idx) => (
                        <Box
                            key={idx}
                            sx={{
                                flex: "0 0 auto",
                                display: "flex",
                                flexDirection: "column",
                                width: "80px",
                                height: "100px",
                                backgroundColor: "#BDC3E0",
                                borderRadius: "10px",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <Typography variant="h6" color="#fff" fontWeight="bold">
                                {project.projectCode}
                            </Typography>
                            <Typography variant="h4" color="#fff" fontWeight="bold">
                                {project.rpi}
                            </Typography>
                        </Box>
                    ))}

                    <style>
                        {`
              .scroll-box::-webkit-scrollbar {
                display: none;
              }
              .scroll-box.active {
                cursor: grabbing;
                cursor: -webkit-grabbing;
              }
            `}
                    </style>
                </Box>
            )}
        </Card>
    );
};

export default RPICard;
